import { createCssVarTokens } from 'UI/theme/cssVariables';

export const lightColors = {
  black: '#1A1C21',
  borderColor: '#ECEDF0',
  componentFill: '#CDD8E6',
  darkGrey: '#525764',
  grey: '#9CA6B5',
  greyFocus: '#a9a9a9',
  iconInactive: '#A3A8B4',
  inactiveSideBarTab: '#E1E4EB',
  lightButtonHover: '#e5eafa9e',
  lightgray: '#bbbbbb',
  lightgrey: '#f2f2f2',
  lightPurple: '#ECEFFF',
  lightText: '#969BA5',
  linkWater: '#E5EAFA',
  middleGrey: '#D4D7DD',
  navLink: '#4B5EB0',
  notificationRead: '#FAFBFD',
  notificationUnRead: '#F0F3F7',
  oxford: '#707070',
  red: '#E9250C',
  sideBar: '#FAFBFD',
  silverGrey: '#F7F7F7',
  success: '#4056F4',
  transparent: 'transparent',
  user: {
    purple: {
      background: '#E2D9FB',
      text: '#5C40F4'
    },
    red: {
      text: '#F2453D'
    }
  },
  white: '#FFFFFF'
};

/**
 * Same keys as `lightColors`. Names describe the light-mode look; in dark mode each key keeps its
 * role (`black` is primary text, `white` is a surface, light greys are dark surfaces/borders).
 */
export const darkColors = {
  black: '#E6E9EF',
  borderColor: '#3D434F',
  componentFill: '#353A44',
  darkGrey: '#C8CED7',
  grey: '#9199A7',
  greyFocus: '#9199A7',
  iconInactive: '#9199A7',
  inactiveSideBarTab: '#2A2E37',
  lightButtonHover: 'rgba(139, 157, 245, 0.16)',
  lightgray: '#676E7B',
  lightgrey: '#23272F',
  lightPurple: '#2C3143',
  lightText: '#9199A7',
  linkWater: '#2C3143',
  middleGrey: '#353A44',
  navLink: '#A6B4F3',
  notificationRead: '#1C1F26',
  notificationUnRead: '#22252D',
  oxford: '#A9B2BF',
  red: '#F2766E',
  sideBar: '#15171C',
  silverGrey: '#23272F',
  success: '#8B9DF5',
  transparent: 'transparent',
  user: {
    purple: {
      background: '#2E2650',
      text: '#A38FF4'
    },
    red: {
      text: '#F2766E'
    }
  },
  white: '#1C1F26'
};

export const colorsByMode = Object.freeze({ light: lightColors, dark: darkColors });

/**
 * Theme-aware legacy colors: each value is `var(--fp-colors-<key>, <light value>)`.
 * Prefer `theme.palette.*` in new code.
 */
export const colors = createCssVarTokens(lightColors, ['colors']);
